module.exports = __webpack_public_path__ + "static/montserrat-91c037c541aedfe9ba55ed17687107a5.mp4";